import { Schema } from 'effect';

/**
 * Every part a configured model can be built out of, as the engine names them.
 *
 * The frontend's copy of the backend's own `ComponentType`, and it is copied rather than loosened to a string because the copy is meant to fail. A component the engine sends and this list does not have means the two have drifted, and every configuration carrying that component refuses to decode. That is deliberate: it
 * surfaces on the first configuration that uses the new component, in test, rather than as a control that silently never appears in production.
 *
 * Adding one is therefore a frontend change, and a deliberate one. Kept in the backend's order rather than sorted, so the two lists can be read side by side the day that has to happen.
 */
export const ComponentTypes = Schema.Literals([
	'___',
	'mdl',
	'krm',
	'pfs',
	'ovk',
	'unk',
	'vsk',
	'hsk',
	'ps1',
	'ps2',
	'ps3',
	'ps4',
	'ps5',
	'ps6',
	'ps7',
	'ps8',
	'ps9',
	'ps10',
	'ps11',
	'ps12',
	'ps13',
	'ps14',
	'ps15',
	'ps16',
	'ps17',
	'ps18',
	'ps19',
	'ps20',
	'ps21',
	'ps22',
	'ps23',
	'ps24',
	'kf1',
	'kf2',
	'kf3',
	'kf4',
	'kf5',
	'kf6',
	'kf7',
	'kf8',
	'kf9',
	'kf10',
	'kf11',
	'kf12',
	'kf13',
	'kf14',
	'kf15',
	'kf16',
	'kf17',
	'kf18',
	'kf19',
	'kf20',
	'kf21',
	'kf22',
	'kf23',
	'kf24',
	'kf25',
	'ram',
	'ovr',
	'unr',
	'vsr',
	'hsr',
	'tsl',
	'sp1',
	'sp2',
	'sp3',
	'sp4',
	'sp5',
	'sp6',
	'sp7',
	'sp8',
	'sp9',
	'sp10',
	'sp11',
	'sp12',
	'sp13',
	'sp14',
	'sp15',
	'sp16',
	'sp17',
	'sp18',
	'sp19',
	'sp20',
	'sp21',
	'sp22',
	'sp23',
	'sp24',
	'rf1',
	'rf2',
	'rf3',
	'rf4',
	'rf5',
	'rf6',
	'rf7',
	'rf8',
	'rf9',
	'rf10',
	'rf11',
	'rf12',
	'rf13',
	'rf14',
	'rf15',
	'rf16',
	'rf17',
	'rf18',
	'rf19',
	'rf20',
	'rf21',
	'rf22',
	'rf23',
	'rf24',
	'rf25',
	'ogl',
	'sgl',
	'ugl',
	'lsh',
	'sst',
	'tst',
	'dok',
	'mst',
	'ao1',
	'ao2',
	'ao3',
	'ao4',
	'ao5',
	'rv1',
	'rv2',
	'rv3',
	'rv4',
	'rv5',
	'tgm',
	'sts',
	'slut',
	'psv',
	'psl',
	'spv',
	'spl',
	'hlf',
	'gl1',
	'gl2',
	'gl3',
	'prf1',
	'prf2',
	'prf3',
	'prf4',
	'prf5',
	'tslk',
	'gb1',
	'gb2',
	'nbgl',
	'fyld',
	'glst',
	'hgsl',
	'tbh',
	'ogl1',
	'ogl2',
	'ogl3',
	'sgl1',
	'sgl2',
	'sgl3',
	'ugl1',
	'ugl2',
	'ugl3',
	'nbg1',
	'nbg2',
	'nbg3',
	'tsl1',
	'tsl2',
	'tsl3',
	'gb1a',
	'gb1b',
	'gb2a',
	'gb2b',
	'gb3a',
	'gb3b',
	'pv1',
	'pv2',
	'pv3',
	'pv4',
	'pv5',
	'afd',
	'vgrp',
	'mtxt',
	'tpv',
	'tpl',
	'sml',
	'prf6',
	'prf7',
	'prf8',
	'prf9',
	'spn',
	'spvi',
	'spvu',
	'spli',
	'splu',
	'spvg',
	'splg',
	'oka',
	'okb',
	'uka',
	'ukb',
	'vka',
	'vkb',
	'hka',
	'hkb',
	'ora',
	'orb',
	'ura',
	'urb',
	'vra',
	'vrb',
	'hra',
	'hrb',
	'fvs',
	'kpt',
	'kpb',
	'khj',
	'kdi',
	'kdy',
	'extp',
	'spvp',
	'splp',
	'tvsr',
	'rf0',
	'fri1',
]);

/** One of the parts a configured model can be built out of. */
export type IComponentType = typeof ComponentTypes.Type;
